// Évaluation PURE des conditions d'affichage des grilles d'inspection
// (format conditions_affichage de ConditionEditor). Aucune dépendance React :
// partagée par l'inspection terrain et le formulaire public d'auto-inspection.

/**
 * Évalue un objet conditions_affichage en fonction des valeurs des éléments.
 * @param {object|null} conditions - l'objet conditions_affichage
 * @param {object} values - map {element_id: valeur}
 * @returns {boolean} true si l'élément doit être affiché
 */
export const evaluerConditionsAffichage = (conditions, values) => {
  if (!conditions || !conditions.regles || conditions.regles.length === 0) return true;
  const op = conditions.operateur_logique || 'AND';

  const resultats = conditions.regles.map((regle) => {
    const val = values?.[regle.element_id];
    const cible = regle.valeur;
    const valStr = val === null || val === undefined ? '' : String(val);
    const valArr = Array.isArray(val) ? val.map(String) : [valStr];

    switch (regle.operateur) {
      case '=':
        return valArr.includes(String(cible));
      case '≠':
        return !valArr.includes(String(cible));
      case 'contient':
        return valArr.some(v => v.toLowerCase().includes(String(cible).toLowerCase()));
      case 'ne_contient_pas':
        return !valArr.some(v => v.toLowerCase().includes(String(cible).toLowerCase()));
      case 'vide':
        return !val || (Array.isArray(val) && val.length === 0) || valStr === '';
      case 'rempli':
        return !!val && !(Array.isArray(val) && val.length === 0) && valStr !== '';
      default:
        return true;
    }
  });

  return op === 'AND' ? resultats.every(Boolean) : resultats.some(Boolean);
};

/**
 * Superpose à `valueById` (clés plates, construit sur toute la grille) les valeurs
 * D'INSTANCE des items de la section répétable en cours de rendu.
 *
 * Chaque instance K d'une section répétable stocke ses réponses sous
 * `section_{s}_inst_{K}_item_{i}` : une condition d'affichage qui référence un item
 * de la MÊME section doit donc être évaluée avec les valeurs de la MÊME instance
 * (l'instance #2 ne doit pas réagir aux réponses de l'instance #1).
 * Les items des AUTRES sections gardent leurs valeurs plates. Un item d'une AUTRE
 * section répétable reste indéterminé (ambigu : quelle instance ? — comportement
 * inchangé : la condition le voit vide).
 *
 * @param {object} valueById - map element_id → valeur (clés plates), toute la grille.
 * @param {Array} items - items de la section en cours de rendu.
 * @param {number} sectionIdx - index de la section en cours de rendu.
 * @param {number|null} instanceIdx - instance en cours, ou null si section non répétable.
 * @param {object} resultats - dict brut des réponses de l'inspection.
 * @returns {object} map element_id → valeur à passer à evaluerConditionsAffichage.
 */
export const valeursPourInstance = (valueById, items, sectionIdx, instanceIdx, resultats) => {
  if (instanceIdx === null || instanceIdx === undefined) return valueById;
  const v = { ...valueById };
  (items || []).forEach((it, iIdx) => {
    if (typeof it === 'object' && it?.id) {
      v[it.id] = (resultats || {})[`section_${sectionIdx}_inst_${instanceIdx}_item_${iIdx}`];
    }
  });
  return v;
};
